import template from "./mileage_report.html";
import controller from "./mileage_report.controller";
import "./mileage_report.scss";

let mileageReportComponent = {
    restrict: "E",
    bindings: {},
    template,
    controller
};
export default mileageReportComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/mileage_report/mileage_report.component.js